import { type ReactElement, lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import type ILazyComponent from '^types/common/ILazyComponent';
import {
  getEntryPointPageRoutePath, getEntryPointPageRouteUrl, getErrorRoutePath,
  getMainFlowPageRoutePath, getSuccessRoutePath, getSupportPageRoutePath,
} from '^utils/routingHelpers';
import sharedHistory from '^sharedHistory';
import ErrorPage from '^components/ErrorPage';
import PageSkeleton from '^components/PageSkeleton';
import SuccessPage from '^components/SuccessPage';
import SupportPage from '^pages/SupportPage';

import HistoryRouter from './HistoryRouter';

const EntryPoint = lazy((): Promise<ILazyComponent> => import('^pages/EntryPoint'));
const MainFlow = lazy((): Promise<ILazyComponent> => import('^pages/MainFlow'));

const { plateNumber } = window.xprops;

const redirectUrl = plateNumber
  ? getEntryPointPageRouteUrl({
    plateNumber,
  })
  : getEntryPointPageRoutePath();

const RoutingRules = (): ReactElement => (
  <Suspense fallback={<PageSkeleton />}>
    <HistoryRouter history={sharedHistory}>
      <Routes>
        <Route
          path={getEntryPointPageRoutePath()}
          element={<EntryPoint />}
        />

        <Route
          path={getMainFlowPageRoutePath()}
          element={<MainFlow />}
        />

        <Route
          path={getErrorRoutePath()}
          element={<ErrorPage />}
        />

        <Route
          path={getSuccessRoutePath()}
          element={<SuccessPage />}
        />

        <Route
          path={getSupportPageRoutePath()}
          element={<SupportPage />}
        />

        <Route
          path="*"
          element={(
            <Navigate
              to={redirectUrl}
              replace
            />
          )}
        />
      </Routes>
    </HistoryRouter>
  </Suspense>
);

export default RoutingRules;
